import { useMemo } from 'react';

import { Popover, message } from 'antd';

import SvgIcon from '@lcsc-ui/components/SvgIcon';
import { buriedPoint } from '@lcsc-ui/utils/buriedPoint';
import Utils from '@lcsc-ui/utils/Utils';

// 复制商品信息
export default function CopyProductButton(props) {
  const { productVO, providerAlias } = props;

  const isLcBook = useMemo(() => {
    return Utils.isLcBook(productVO?.provider);
  }, [productVO]);

  function copyProduct() {
    buriedPoint({
      op: 'copy',
    });
    let template =
      `名称：${productVO?.productName}\n` +
      `型号：${productVO?.productModel}\n` +
      `品牌：${productVO?.productGradePlateName}\n` +
      `封装：${productVO?.encapsulationModel}\n` +
      `编号：${productVO?.productCode}`;
    if (productVO?.provider) {
      template =
        `渠道：${isLcBook ? '立创订货' : providerAlias || productVO?.provider}\n` +
        `型号：${productVO?.productCodeManufacturer}\n` +
        `品牌：${isLcBook ? productVO?.brandName : productVO?.productGradePlateName}\n` +
        `封装：${productVO?.selfStandard || productVO?.encapsulationModel || ''}`;
    }
    Utils.copyText(template, () => {
      message.success('已复制商品信息');
    });
  }

  return (
    <Popover
      content="点击可复制商品信息"
      overlayClassName="lcsc-popover-wrapper"
      overlayInnerStyle={{ padding: '10px', fontSize: '12px' }}
    >
      <button
        className="mr-[10px] flex h-[26px] w-[75px] items-center justify-center rounded-[13px] bg-[#F5F6F9] text-[#333] hover:bg-[#ECEEF0]"
        onClick={() => copyProduct()}
      >
        <SvgIcon app="so" iconName="copy" className="mr-[5px] inline-block h-[14px] w-[14px]"></SvgIcon>
        {/* <i className="mr-[5px] inline-block h-[14px] w-[14px] bg-[url(https://static.szlcsc.com/ecp/assets/newWeb/so/copy.svg)]"></i> */}
        <span>复制</span>
      </button>
    </Popover>
  );
}
